import React, { useEffect, useRef, useState } from 'react';
import { drawFrequencyCanvas, drawTimeCanvas } from '../../render/spectrum';
import { RydAudioInputSelector } from '../widgets/data-input/RydAudioInputSelector';
import { OutputNode } from 'tone';


export function RydSpectrogram({
    audioContext,
    // Optional props for customization
    style = {},
    width = 500,
    height = 200,
    source

}: {
    audioContext: AudioContext,
    style?: React.CSSProperties,
    width?: number,
    height?: number,
    source?: OutputNode
}) {

    const timeCanvasRef = useRef<HTMLCanvasElement>(null);
    const freqCanvasRef = useRef<HTMLCanvasElement>(null);
    const [devices, setDevices] = useState<MediaDeviceInfo[]>([]);
    const [selectedDeviceId, setSelectedDeviceId] = useState<string>('');
    const [detectedNote, setDetectedNote] = useState<string>('');
    const [detectedFreq, setDetectedFreq] = useState<number>(0);

    // Helper: converts a frequency (Hz) into a musical note.
    const frequencyToNote = (frequency: number): string => {
        if (frequency <= 0) return '';
        const noteNames = ['C', 'C#', 'D', 'D#', 'E', 'F',
            'F#', 'G', 'G#', 'A', 'A#', 'B'];
        const noteNumber = Math.round(12 * (Math.log(frequency / 440) / Math.log(2))) + 69;
        const octave = Math.floor(noteNumber / 12) - 1;
        const noteIndex = noteNumber % 12;
        return noteNames[noteIndex] + octave;
    };

    useEffect(() => {
        // if (!selectedDeviceId && !source) return;
        if (!source) return;
        // let audioContext: AudioContext | null = null;
        let mediaStream: MediaStream | null = null;
        let animationId: number;

        const setupAudio = () => {
            // try {
                // audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
                // let _source = !!source ? source : null;
                // if (!source) {
                //     mediaStream = await navigator.mediaDevices.getUserMedia({
                //         audio: { deviceId: { exact: selectedDeviceId } }
                //     });
                //     _source = audioContext.createMediaStreamSource(mediaStream);
                // }
                const analyser = audioContext.createAnalyser();
                analyser.fftSize = 8192;
                source.connect(analyser);
                const bufferLength = analyser.frequencyBinCount;
                const timeData = new Uint8Array(bufferLength);
                const freqData = new Uint8Array(bufferLength);

                const draw = () => {
                    analyser.getByteTimeDomainData(timeData);
                    analyser.getByteFrequencyData(freqData);

                    // Draw waveform
                    const timeCanvas = timeCanvasRef.current;
                    drawTimeCanvas(timeCanvas, timeData, bufferLength);

                    // Draw logarithmically scaled frequency bars
                    const freqCanvas = freqCanvasRef.current;
                    drawFrequencyCanvas(freqCanvas, freqData, bufferLength);

                    // Compute dominant frequency
                    if (audioContext) {
                        const sampleRate = audioContext.sampleRate;
                        let maxIndex = 0, maxValue = -Infinity;
                        for (let i = 1; i < freqData.length; i++) {
                            if (freqData[i] > maxValue) {
                                maxValue = freqData[i];
                                maxIndex = i;
                            }
                        }
                        // The frequency resolution is (sampleRate/2) / bufferLength.
                        const dominantFrequency = maxIndex * (sampleRate / 2) / bufferLength;
                        setDetectedFreq(dominantFrequency);
                        const noteName = frequencyToNote(dominantFrequency);
                        setDetectedNote(noteName);
                    }

                    animationId = requestAnimationFrame(draw);
                };

                draw();
            // } catch (err) {
            //     console.error('Error setting up audio:', err);
            // }
        };

        setupAudio();

        return () => {
            cancelAnimationFrame(animationId);
            // if (mediaStream) {
            //     mediaStream.getTracks().forEach(track => track.stop());
            // }
            // if (audioContext) {
            //     audioContext.close();
            // }
        };
    // }, [selectedDeviceId, source]);
    }, []);
    return (
        <>
            <div>
                {/* <RydAudioInputSelector selectedDeviceId={selectedDeviceId} setSelectedDeviceId={setSelectedDeviceId} /> */}
                <div style={{ marginBottom: '10px' }}>
                    <ul>
                        <li><strong>Dominant Frequency:</strong> {detectedFreq.toFixed(2)} Hz</li>
                        <li><strong>Note:</strong> {detectedNote}</li>
                    </ul>
                </div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                    <div>
                        <h3>Waveform</h3>
                        <canvas
                            ref={timeCanvasRef}
                            width={500}
                            height={200}
                            style={{ border: '1px solid #444' }}
                        />
                    </div>
                    <div>
                        <h3>Frequency Spectrum</h3>
                        <canvas
                            ref={freqCanvasRef}
                            width={500}
                            height={200}
                            style={{ border: '1px solid #444' }}
                        />
                    </div>
                </div>


            </div>
        </>
    );
}